import { Actions } from "services/AccessControl";
import { isAllowed } from "lib/permToolkit";

export default (subject, action, ressource) => { 

    switch (action) {
        case Actions.Read:
            return true;
        case Actions.Manage:
            return isAllowed(subject, "GestionParametres");
        default: 
            return false;
    };
}